import React, { MouseEventHandler, useState } from "react";
import { useNavigate } from "react-router-dom";
export interface BrandButtonProps {
    text: string;
    href?: string;
    title?: string;
    backgroundColor?: string;
    classNameAttr?: string;
    isNavigateBtn?: boolean;
    onClick?: any;
}

export const defaultDarkBrandColor = "#021d1f";
export const defaultBtnHoverColor = "#D09D86";

const BrandButton = (props: BrandButtonProps) => {
    const navigate = useNavigate();
    const bgColor = props.backgroundColor ? props.backgroundColor : defaultDarkBrandColor;
    const [backgroundColor, setBackgroundColor] = useState(bgColor);
    const mouseOver = () => {
        setBackgroundColor(defaultBtnHoverColor)
    }
    const mouseLeave = () => {
        setBackgroundColor(bgColor)
    }
    if(props.onClick) {
        return (
            <a onMouseOver={mouseOver} onMouseLeave={mouseLeave}  className={`newsletter-btn ${props.classNameAttr ? props.classNameAttr : null}`} style={{"background": bgColor}} onClick={props.onClick} title={props.title}>
                <span style={{"background": backgroundColor, "fontSize": "14px"}}>{props.text}</span>
            </a>
        )
    }
    if(props.isNavigateBtn) {
        return (
            <span onClick={() => navigate(props.href || '/')} onMouseOver={mouseOver} onMouseLeave={mouseLeave}  className={`newsletter-btn ${props.classNameAttr ? props.classNameAttr : null}`} style={{"background": bgColor}} title={props.title}>
                <span style={{"background": backgroundColor, "fontSize": "14px"}}>{props.text}</span>
            </span>
        )
    }
    else {
        return (
            <a onMouseOver={mouseOver} onMouseLeave={mouseLeave}  className={`newsletter-btn ${props.classNameAttr ? props.classNameAttr : null}`} style={{"background": bgColor}} href={props.href} title={props.title}>
                <span style={{"background": backgroundColor, "fontSize": "14px"}}>{props.text}</span>
            </a>
        )
    }
    
}

export default BrandButton;